import React, { useEffect, useRef, useState } from 'react'
import { faCaretRight, faEnvelopeCircleCheck, faXmark, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpen, faBell, faMessage } from '@fortawesome/free-regular-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/UserContext';
import './Page-css/ClientNavbar2.css'
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify'
import { url } from '../../constants/url';
import { capitalizeFirstNameRole } from '../../utils/capitalFirsrNameRole';
import GuidedTour from '../../Isecurion-components/Pages/GuidedTour';

const ClientNavbar2 = (props) => {

    const { projectData, matchedData, projectName } = props

    const { user, userRole, logout, mfaTour, fetchNotification,
        notificationCount, notificationData, emailVer, company,
        setIsSidebarCollapsed, userPermission, multifactor, checkAuth } = useAuth()

    const firstLetter = user ? user.charAt(0).toUpperCase() : '';

    const location = useLocation();
    const { pathname } = location;

    const [openNotification, setOpenNotification] = useState(false);
    const [hoverOnEnvelope, setHoverOnEnvelope] = useState(false)
    const [prevNotificationCount, setPrevNotificationCount] = useState(notificationCount);
    const [bounce, setBounce] = useState(false);

    const [openClientUpdatePassword, setOpenClientUpdatePassword] = useState(false)
    const [confirmLogout, setConfirmLogout] = useState(false)

    const [openPassword, setOpenPassword] = useState(false)
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState('')
    const [oldPasswordError, setOldPasswordError] = useState('')
    const [newPasswordError, setNewPasswordError] = useState('')
    const [confirmPasswordError, setConfirmPasswordError] = useState('')

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordView, setPasswordView] = useState(false);

    const [showClientDropdown, setShowClientDropdown] = useState(false);
    const specialChars = /[!@#$%^&*(),.?":{}|<>]/;

    const [showTour, setShowTour] = useState(mfaTour);
    const [currentStep, setCurrentStep] = useState(0);

    const [loading, setLoading] = useState(false);
    const [openIdentity, setOpenIdentity] = useState(false)
    const [otpSent, setOTPSent] = useState(false)
    const [otp, setOtp] = useState(["", "", "", "", "", ""])
    const [otpError, setOtpError] = useState(false)

    const inputRefs = useRef([]);

    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [showResend, setShowResend] = useState(true);

    const tourSteps = [
        {
            target: '.navbar2_isec',
            content: 'Click here to view your profile and enable/disable multi factor authentication.',
            placement: 'bottom',
        },
    ];


    const navigate = useNavigate()

    const handleNotification = () => {
        setOpenNotification(true)
        fetchNotification()
    }

    const handleOnEnvelope = () => {
        setHoverOnEnvelope(true);
    };
    const handleOutEnvelope = () => {
        setHoverOnEnvelope(false);
    };

    const isCurrentPage = (page) => {
        return page === pathname;
    };

    const updateSuccess = () => {
        toast.success("Password successfully updated...", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        })
    }

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const togglePasswordView = () => {
        setPasswordView(!passwordView);
    };

    const formatTime = (time) => {
        const now = new Date();
        const messageTime = new Date(time);
        const diffInMs = now - messageTime;

        const seconds = Math.floor(diffInMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 1) {
            return messageTime.toLocaleDateString();
        } else if (days === 1) {
            return "1 day ago";
        } else if (hours >= 1) {
            return `${hours}h ago`;
        } else if (minutes >= 1) {
            return `${minutes}m ago`;
        } else {
            return "Now";
        }
    };

    const handleReadNotification = async (id) => {
        try {
            const response = await fetch(`${url}/markclientread`, {
                method: "PUT",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: id
                })
            });
            if (response.status === 200) {
                fetchNotification()
                return
            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchNotification();
        if (notificationCount > prevNotificationCount) {
            setBounce(true);
            const timeout = setTimeout(() => setBounce(false), 600);
            return () => clearTimeout(timeout);
        }
        setPrevNotificationCount(notificationCount);
    }, [notificationCount, prevNotificationCount]);

    const toggleClientDropdown = () => {
        setShowClientDropdown(!showClientDropdown);
    };

    const handleClientPasswordClose = () => {
        setNewPassword('')
        setConfirmPassword('')
        setOldPassword('')
        setNewPasswordError('')
        setConfirmPasswordError('')
        setOldPasswordError('')
        setOpenClientUpdatePassword(false)
    }

    const handleUpdatePassword = async (e) => {
        e.preventDefault()
        if (oldPassword === '') {
            setOldPasswordError("Enter your old password")
        } else if (newPassword === '') {
            setNewPasswordError("Enter your new password")
        } else if (oldPassword === newPassword) {
            setNewPasswordError("Old password and New password should not be same!")
        } else if (confirmPassword === '') {
            setConfirmPasswordError("Confirm your password ")
        } else if (newPassword !== confirmPassword) {
            setConfirmPasswordError("Password does not match !...")
            return;
        } else if (newPassword.length < 8) {
            setNewPasswordError("Password should be minimum of 8 character")
            return;
        } else if (!specialChars.test(newPassword)) {
            setNewPasswordError("Password should include at least one special character")
            return;
        } else if (!/[A-Z]/.test(newPassword)) {
            setNewPasswordError("Password should include at least one capital alphabet")
            return;
        } else {
            try {
                const response = await fetch(`${url}/updateclientpassword`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        oldPassword,
                        newPassword,
                        confirmPassword
                    })
                })
                if (response.status === 403) {
                    toast.error("Invalid old password", {
                        position: "top-right",
                        autoClose: 2500,
                        pauseOnHover: false,
                    });
                    return
                }
                if (response.status === 400) {
                    return logout()
                }
                if (response.status === 200) {
                    setOldPassword('')
                    setNewPassword('')
                    setConfirmPassword('')
                    updateSuccess()
                    setTimeout(async () => {
                        logout()
                    }, 1000)
                }
                if (response.status === 440) {
                    logout()
                    toast.error("User logout due to inactivity", {
                        position: 'top-right',
                        autoClose: 2500,
                        pauseOnHover: false,
                    });
                    return
                }

            } catch (error) {
                toast.error("Invalid old password", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }
        }
    }

    const handleLogout = async () => {
        try {
            await logout()
            setConfirmLogout(false)
        } catch (error) {
            alert(error.message)
        }
    }

    const handleToggle = () => {
        setLoading(true);
        setOpenIdentity(true)
    }

    const getGreeting = () => {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 12) return 'Good Morning';
        if (hour >= 12 && hour < 17) return 'Good Afternoon';
        if (hour >= 17 && hour < 21) return 'Good Evening';
        return 'Good Night';
    };

    const permissionMap = {
        "level 1": "Executive Policy",
        "level 2": "Manager Policy",
        "level 3": "Lead Policy",
        "level 4": "Engineer Policy",
    };

    function getPermissionLabel(perm) {
        if (!perm) return "";

        const match = String(perm).toLowerCase().match(/level\s*([1-4])/i);
        if (match) {
            const key = `level ${match[1]}`;
            return permissionMap[key] || "";
        }
        return String(perm).charAt(0).toUpperCase() + String(perm).slice(1);
    }

    function maskEmail(email) {
        const [username, domain] = email.split('@');
        const maskedUsername =
            username.length <= 2
                ? username[0] + '*'.repeat(username.length - 1)
                : username[0] + '*'.repeat(username.length - 2) + username.slice(-1);

        return maskedUsername + '@' + domain;
    }

    const handleChange = (element, index) => {
        const value = element.value.replace(/\D/g, "");
        if (value.length > 1) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input automatically
        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }

    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        } else if (e.key === "Enter") {
            verifyOTP(otp.join(""));
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
        if (!pasteData) return;

        const newOtp = pasteData.split("");
        for (let i = 0; i < 6; i++) {
            newOtp[i] = newOtp[i] || "";
        }

        setOtp(newOtp);
        setOtpError(false)

        // Focus last filled box
        const lastFilled = newOtp.findLastIndex((d) => d !== "");
        if (lastFilled !== -1 && inputRefs.current[lastFilled]) {
            inputRefs.current[lastFilled].focus();
        }

    };

    const startTimer = (duration = 60) => {
        setTimer(duration);
        setCanResend(false);

        const interval = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }

    const sendOTP = async () => {
        try {
            const response = await fetch(`${url}/sendidentityotp`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            })
            if (response.status === 200) {
                setOTPSent(true)
                startTimer()
                setShowResend(true)
                toast.success("OTP sent successfully", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
            if (response.status !== 200) {
                setOTPSent(false)
                return
            }
        } catch (error) {
            console.log(error)
            setOTPSent(false)
        }
    }

    const verifyOTP = async (e) => {
        e.preventDefault();
        if (!otp.join('')) {
            setOtpError(true);
            return;
        } else {
            try {
                const response = await fetch(`${url}/verifyidentityotp`, {
                    method: "POST",
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        otp
                    })
                })
                if (response.status === 200) {
                    setOtp(['', '', '', '', '', ''])
                    setOTPSent(false)
                    setOpenIdentity(false)
                    checkAuth()
                    setLoading(false)
                    toast.success("MFA updated", {
                        position: 'top-right',
                        autoClose: 2500,
                        pauseOnHover: false,
                    });
                    return
                }
                if (response.status === 400) {
                    toast.error("Incorrect OTP", {
                        position: 'top-right',
                        autoClose: 2500,
                        pauseOnHover: false,
                    });
                    return
                }
                if (response.status === 406) {
                    toast.error("OTP expired", {
                        position: 'top-right',
                        autoClose: 2500,
                        pauseOnHover: false,
                    });
                    return
                }

            } catch (error) {
                console.log(error)
            }
        }
    }

    const resendIdentityOTP = async () => {
        if (!canResend) return;
        setShowResend(false);

        try {
            const response = await fetch(`${url}/resendidentityotp`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
            })
            if (response.status === 200) {
                setShowResend(true);
                startTimer(60)
                toast.success("OTP sent successfully", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            } else {
                setCanResend(true);
                setShowResend(true);
            }
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className='navbar2_client'>
            <div className='client_navbar_data'>
                <div className='client_navbar2_route'>
                    <div className='navbar_collapse_button'>
                        <button
                            className="btn_navbar"
                            onMouseEnter={() => setIsSidebarCollapsed(true)} // Expand sidebar
                            onMouseLeave={() => setIsSidebarCollapsed(false)} // Collapse sidebar
                        >
                            <Icon icon="prime:bars" width="22" height="22" />
                        </button>
                    </div>
                    <div className='navbar2_route_name'>
                        <h3>{getGreeting()}...! {user}</h3>
                    </div>
                </div>

                <div className='client_navbar2_content'>

                    <button onClick={handleNotification} style={{ color: 'white' }} className={
                        notificationCount > 0 ? "navbar_content_notify" : "navbar_content_empty"
                    }>
                        <Icon icon="bitcoin-icons:bell-filled" width="26" height="26" />
                        {notificationCount > 0 && (
                            <span className='notification_badge_navbar2' >
                                {notificationCount > 9 ? '9+' : notificationCount}
                            </span>
                        )}
                    </button>

                    <div className='navbar2_isec' onClick={toggleClientDropdown}>
                        <h4>{firstLetter}</h4>
                    </div>

                    {showClientDropdown && (
                        <div className="isecurion_user_dropdown">
                            <div className='user_isecurion_dropdown_profile'>
                                <div className="user_profile_headings">
                                    <h1>User Profile</h1>
                                    <div className='wrap_cancel_button_client'>
                                        <button onClick={() => { setShowClientDropdown(false) }} >
                                            <Icon icon="material-symbols:close" width="20" height="20" />
                                        </button>
                                    </div>
                                </div>

                                {openClientUpdatePassword ? (
                                    <>
                                        <div className='update_password_container'>
                                            <div className='update_password_header'>
                                                <div className='update_password_back_icon' onClick={() => setOpenClientUpdatePassword(false)}>
                                                    <Icon icon="basil:arrow-left-outline" width="24" height="24" />
                                                </div>
                                                <div className='update_password_heading'>
                                                    Update password
                                                </div>
                                            </div>
                                            <div className='update_password_form_container'>
                                                <div className='update_password_inputs'>
                                                    <label>Current Password</label>
                                                    <input type={passwordVisible ? 'text' : 'password'} placeholder='Enter Your Current Password' value={oldPassword} onChange={(e) => {
                                                        setOldPassword(e.target.value)
                                                        setOldPasswordError('')
                                                    }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleUpdatePassword(e)
                                                                e.target.blur();
                                                            }
                                                        }} />
                                                    <FontAwesomeIcon
                                                        icon={passwordVisible ? faEye : faEyeSlash}
                                                        onClick={togglePasswordVisibility}
                                                        className='update_eye-icon'
                                                    />
                                                    {oldPasswordError && oldPassword === '' ? <p>{oldPasswordError}</p> : ''}
                                                </div>

                                                <div className='update_password_inputs'>
                                                    <label>New Password</label>
                                                    <input
                                                        type={passwordView ? 'text' : 'password'}
                                                        placeholder="Enter Your New Password"
                                                        value={newPassword}
                                                        onChange={(e) => {
                                                            setNewPassword(e.target.value);
                                                            setNewPasswordError('');
                                                        }}

                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleUpdatePassword(e)
                                                                e.target.blur();
                                                            }
                                                        }}
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={passwordView ? faEye : faEyeSlash}
                                                        onClick={togglePasswordView}
                                                        className='update_eye-icon'
                                                    />
                                                    {newPasswordError && <p>{newPasswordError}</p>}

                                                </div>

                                                <div className='update_password_inputs'>
                                                    <label>Confirm Password</label>
                                                    <input type='password' placeholder='Re-Enter Your New Password' value={confirmPassword}
                                                        onChange={(e) => {
                                                            setConfirmPassword(e.target.value)
                                                            setConfirmPasswordError('')
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                handleUpdatePassword(e)
                                                                e.target.blur();
                                                            }
                                                        }}
                                                    />
                                                    {confirmPasswordError && <h5>{confirmPasswordError} </h5>}
                                                </div>
                                                <div className='wrap_update_isec_button'>
                                                    <button onClick={handleUpdatePassword}>Save</button>
                                                </div>

                                            </div>
                                        </div>
                                    </>) : (
                                    <>
                                        <div className='wrap_user_isecurion_data_profile'>
                                            <div className='wrap_isecurion_name_drop'>
                                                <h4>{firstLetter}</h4>
                                            </div>
                                            <div className='wrap_isecurion_user_detail'>
                                                <table className='profile_table'>
                                                    <tbody>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>:</td>
                                                            <td>{user}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Mail Id</td>
                                                            <td>:</td>
                                                            <td>{emailVer}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Permission</td>
                                                            <td>:</td>
                                                            <td>{getPermissionLabel(userPermission)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Role</td>
                                                            <td>:</td>
                                                            <td>{capitalizeFirstNameRole(userRole)}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Company Name</td>
                                                            <td>:</td>
                                                            <td>{company}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Multi Factor Authentication</td>
                                                            <td>:</td>
                                                            <td>
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={multifactor}
                                                                        onChange={handleToggle}
                                                                        disabled={loading}
                                                                    // onChange={(e) => setMultifactor(e.target.checked)}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='profile_buttons'>
                                                <button onClick={() => setOpenClientUpdatePassword(true)} style={{ marginRight: '60px' }} >Update Password</button>
                                                <button style={{ width: '100px' }} onClick={handleLogout}>Logout</button>
                                            </div>
                                        </div>
                                    </>
                                )
                                }

                            </div>

                        </div>
                    )}

                    {showTour && (
                        <GuidedTour
                            steps={tourSteps}
                            firstletter={firstLetter}
                            currentStep={currentStep}
                            checkAuth={checkAuth}
                            toggleDropdown={toggleClientDropdown}
                            setCurrentStep={setCurrentStep}
                            onFinish={() => setShowTour(false)}
                        />
                    )}

                    {openIdentity && (
                        <div className="isecurion_user_dropdown">
                            <div className='isecurion_identity_dropdown'>
                                <div className='wrap_identity_heading'>
                                    <h1>Multi Factor Authentication</h1>
                                    <button onClick={() => {
                                        setOpenIdentity(false)
                                        setLoading(false);
                                        setOTPSent(false)
                                    }}><FontAwesomeIcon icon={faXmark} /></button>
                                </div>
                                <div className='wrap_identify_content'>
                                    <div>
                                        <h2>Verify your identity</h2>
                                        {otpSent ? (
                                            <div>
                                                <p>Enter the OTP sent to <strong>{maskEmail(emailVer)}</strong></p>
                                                <div className="otp-container">

                                                    {otp?.map((digit, index) => (
                                                        <input
                                                            key={index}
                                                            ref={(el) => (inputRefs.current[index] = el)}
                                                            type="text"
                                                            className={`otp-box ${otpError ? "otp-error" : ""}`}
                                                            maxLength={1}
                                                            value={digit}
                                                            onChange={(e) => {
                                                                handleChange(e.target, index)
                                                                if (otpError) setOtpError(false);
                                                            }}
                                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                                            onPaste={handlePaste}
                                                        />
                                                    ))}
                                                </div>
                                                {showResend && (
                                                    <p
                                                        style={{
                                                            marginTop: "10px",
                                                            color: canResend ? "#0077b6" : "#999",
                                                            cursor: canResend ? "pointer" : "not-allowed",
                                                        }}
                                                        onClick={resendIdentityOTP}>
                                                        {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
                                                    </p>
                                                )}
                                            </div>
                                        ) : (
                                            <div>
                                                <p>For Security reasons, we need to verify your identity before proceeding.</p>
                                                <p>A one-time password will be sent to your registered email address <strong>{maskEmail(emailVer)}</strong></p>
                                            </div>
                                        )}

                                        <div className='wrap_send_otp_button'>
                                            {otpSent ? (
                                                <button onClick={verifyOTP}>Verify</button>
                                            ) : (
                                                <button onClick={sendOTP}>Send OTP</button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            </div>

            {/* {openClientUpdatePassword && (
                <div className='isec_confirmation_logout'>
                    <div className='wrap-updatepass'>

                        <div className='wrap_update_text'>
                            <h1 data-testid='UpdatePassword'>Update Password</h1>
                            <button onClick={handleClientPasswordClose}><FontAwesomeIcon icon={faXmark} /></button>
                        </div>

                        <div className='wrap_password_inputs'>
                            <div className='update_password_inputs'>
                                <label>Current Password</label>
                                <input type={passwordVisible ? 'text' : 'password'} placeholder='Enter Your Current Password' value={oldPassword} onChange={(e) => {
                                    setOldPassword(e.target.value)
                                    setOldPasswordError('')
                                }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleUpdatePassword(e)
                                            e.target.blur();
                                        }
                                    }} />
                                <FontAwesomeIcon
                                    icon={passwordVisible ? faEye : faEyeSlash}
                                    onClick={togglePasswordVisibility}
                                    className='update_eye-icon'
                                />
                                {oldPasswordError && oldPassword === '' ? <p>{oldPasswordError}</p> : ''}
                            </div>
                            <div className='update_password_inputs'>
                                <label>New Password</label>
                                <input
                                    type={passwordView ? 'text' : 'password'}
                                    placeholder="Enter Your New Password"
                                    value={newPassword}
                                    onChange={(e) => {
                                        setNewPassword(e.target.value);
                                        setNewPasswordError('');
                                    }}

                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleUpdatePassword(e)
                                            e.target.blur();
                                        }
                                    }}
                                />
                                <FontAwesomeIcon
                                    icon={passwordView ? faEye : faEyeSlash}
                                    onClick={togglePasswordView}
                                    className='update_eye-icon'
                                />
                                {newPasswordError && <p>{newPasswordError}</p>}
                            
                                <ul>
                                    <li>Password should be minimum of 8 character</li>
                                    <li>Password should include at least one special character</li>
                                    <li>Password should include at least one capital alphabet</li>
                                </ul>
                            </div>

                            <div className='update_password_inputs'>
                                <label>Confirm Password</label>
                                <input type='password' placeholder='Re-Enter Your New Password' value={confirmPassword}
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value)
                                        setConfirmPasswordError('')
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleUpdatePassword(e)
                                            e.target.blur();
                                        }
                                    }}
                                />
                                {confirmPasswordError && <h5>{confirmPasswordError} </h5>}
                            </div>
                            <div className='wrap_update_isec_button'>
                                <button onClick={handleUpdatePassword}>Update Password</button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}




            {openNotification && (
                <div className="wrap_client_notification_page">
                    <div className="wrap_client_notification_content">
                        <div className='wrap_notify_content_data'>
                            <div className="notification_headings_client">
                                <h1>Notifications</h1>
                                <div className='wrap_cancel_button_client'>
                                    <button onClick={() => setOpenNotification(false)}>
                                        <Icon icon="material-symbols:close" width="20" height="20" />
                                    </button>
                                </div>

                            </div>
                            <div className="notification_list_client">
                                {notificationData.length > 0 ? (
                                    notificationData
                                        .slice() // Copy of the array
                                        .sort((a, b) => new Date(b.time) - new Date(a.time)) // Sort by time, newest first
                                        .map((message, index) => (
                                            <div
                                                className="notification_content_client"
                                                key={index}>
                                                {!message.read && hoverOnEnvelope && (
                                                    <div className="envelope_hover">
                                                        <p>Mark as read</p>
                                                    </div>
                                                )}
                                                <div style={{ display: "flex", marginBottom: "-10px" }}>
                                                    <p style={{ width: "90%" }}>{formatTime(message.time)}</p>
                                                    <button
                                                        onClick={() => handleReadNotification(message._id)}
                                                        onMouseOver={handleOnEnvelope}
                                                        onMouseOut={handleOutEnvelope}
                                                    >
                                                        {/* Conditional icon based on read status */}
                                                        <FontAwesomeIcon icon={message.read ? faEnvelopeOpen : faEnvelopeCircleCheck} />
                                                    </button>
                                                </div>
                                                <h2
                                                    style={{
                                                        fontWeight: message.read ? '400' : '600', // Conditionally set font weight
                                                        paddingTop: '10px',
                                                    }}
                                                    dangerouslySetInnerHTML={{ __html: message.notification }}
                                                ></h2>
                                            </div>
                                        ))
                                ) : (
                                    <div className="no_notifications">
                                        <h2>Your notifications live here</h2>
                                    </div>
                                )}
                            </div>
                        </div>


                    </div>
                </div>

            )}
        </div>
    )
}

export default ClientNavbar2
